import './eezy-logo--white.svg';
import './vecteezy-logo--black.svg';
import './vecteezy-logo--orange-on-white.svg';
import './vecteezy-logo--white-on-orange.png';
